import { Drawer, List, ListItemButton, ListItemText } from "@mui/material"
import { TableHeaderData } from "../types"

interface IBottomMenuProps {
    open: boolean
    close: () => void
    list: TableHeaderData[]
    setTableHeaderKey: React.Dispatch<React.SetStateAction<string>>
}


export const BottomMenu = (props: IBottomMenuProps) => {

    const { open, close, list, setTableHeaderKey } = props

    const handleOnclick = (key: string) => {
        // console.log('key', key)
        setTableHeaderKey(key)
        close()
    }

    return (
        <Drawer anchor="bottom" open={open} onClose={close} sx={{
            borderRadius: '25px 25px 0px 0px',
            ".MuiPaper-elevation": {
                borderRadius: '25px 25px 0px 0px'
            }
        }}>
            <List sx={{ padding: '10px 20px' }}>
                {[...list.slice(1)].map((row, i) => (
                    <ListItemButton key={i} onClick={() => handleOnclick((row?.key || row?.id) as string)}>
                        <ListItemText>
                            {row?.label}
                        </ListItemText>
                    </ListItemButton>

                ))}
            </List>
        </Drawer>
    )
}